import React, { useEffect } from 'react';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { Auth } from 'aws-amplify';

const KnownUser = (props) => {
    const { user } = useAuthenticator((context) => [context.user]);
   
    // Funktion zum Abrufen der Identity ID
    async function getIdentityId() {
        let credentials = {};
        try {
            credentials = await Auth.currentCredentials();

            // console.log('Cognito identity ID:', credentials.identityId);

            /*
            const userInfo = await Auth.currentUserInfo();// currentUserInfo();
            const identityId = userInfo.id; //.attributes; // ['identities']; // [0].providerName; // Identity ID
            console.log('Cognito Identity ID:', identityId);
            */
        }
        catch (error) {
            console.error('Fehler beim Abrufen der Identity ID:', error);
        }
        try {
            await Auth.updateUserAttributes(user, {
                'custom:identity_id': credentials.identityId,
              });
        }
        catch (error) {
            console.error('Fehler beim Setzen der Identity ID:', error);
        }
    }

    useEffect(() => {
        if (user && user.attributes) {
            getIdentityId();
        }
            // console.log('useEffect called in Menues... isLoaded', daten, speiseplan, isLoaded)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

   /*
    console.log(user);

    user.getSession((err, session) => {
        if (err) {
            console.log(err);
            return;
        }
        console.log('session validity: ' + session.isValid());
        console.log('access token: ' + session.getAccessToken().getJwtToken());
        console.log('id token: ' + session.getIdToken().getJwtToken());
        console.log('refresh token: ' + session.getRefreshToken().getToken());
    })
   */

    return (
        <>
            {user && user.attributes ? user.attributes.name + ' ' + user.attributes.family_name + ', ID: ' + user.attributes['custom:kvsID'] : ''}
        </>
    );
}

export default KnownUser;
